import React, {useState, useEffect} from "react";
import "../style/debtPayOff.css";
import bagImage from "../../../../assets/images/debtPayoff/bag.png";
import { Progress } from "antd";
import NewLoader from "../../../styled-components/loader/NewLoader";
import budgetIcon from "../../../../assets/images/performance.png";
import filterIcon from "../../../../assets/images/debtPayoff/filter.png";
import { Dropdown, Menu } from "antd";

export const Amortization = (props) => {
  const [data, setData] = useState([]);

  function calculateAmortizationPercentage(data) {
    let amortizationPercentages = [];

    for (let i = 0; i < data.length; i++) {
      const loan = data[i];
      const initialLoanAmount = loan["Initial Loan Amount"];
      const monthlyPayment = loan["Monthly Payment"]
        ? parseFloat(loan["Monthly Payment"])
        : null;
      const interestRate = loan["Interest Rate"] ? loan["Interest Rate"] : null;

      // Check if all necessary fields exist
      if (
        initialLoanAmount !== null &&
        monthlyPayment !== null &&
        interestRate !== null
      ) {
        const monthlyInterestRate = interestRate / 12;

        // Calculate total interest payment for the entire loan term
        const totalInterestPayment = initialLoanAmount * monthlyInterestRate;

        // Calculate principal paid for each month's payment
        const principalPaid = monthlyPayment - totalInterestPayment;

        // Calculate amortization percentage
        const amortizationPercentage =
          (principalPaid / initialLoanAmount) * 100;

        // Push the result for this loan to the array
        amortizationPercentages.push({
          id: loan.id,
          amortizationPercentage:  amortizationPercentage.toFixed(2),
          name: loan["Nickname of Liabilities"],
          module: loan.module,
          image:loan.image,
          initialLoanAmount: initialLoanAmount,
          monthlyPayment : monthlyPayment,
          interestRate : interestRate,

        });
      }
    }

    return amortizationPercentages;
  }
  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);

  const sortData = (sortBy) => {
    let sortedData;
    switch (sortBy) {
      case "alphabetical":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (a.item && b.item) {
              return a.item.module.localeCompare(b.item.module);
            } else {
              return 0; // No sorting if module name is missing
            }
          });
        break;
      case "maturityDate":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (a.item && b.item) {
              return (
                new Date(a.item["Maturity Date"]) - new Date(b.item["Maturity Date"])
              );
            } else {
              return 0; // No sorting if maturity date is missing
            }
          });
        break;
      case "percentage":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a.item &&
              b.item &&
              a.item.amortizationPercentage !== undefined &&
              b.item.amortizationPercentage !== undefined
            ) {
              return a.item.amortizationPercentage - b.item.amortizationPercentage;
            } else {
              return 0; // No sorting if amortization percentage is missing
            }
          });
        break;
      case "initialLoanAmount":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a.item &&
              b.item &&
              a.item["Initial Loan Amount"] !== undefined &&
              b.item["Initial Loan Amount"] !== undefined
            ) {
              return a.item["Initial Loan Amount"] - b.item["Initial Loan Amount"];
            } else {
              return 0; // No sorting if initial loan amount is missing
            }
          });
        break;
      case "interestRate":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a.item &&
              b.item &&
              a.item["Interest Rate"] !== undefined &&
              b.item["Interest Rate"] !== undefined
            ) {
              return a.item["Interest Rate"] - b.item["Interest Rate"];
            } else {
              return 0; // No sorting if interest rate is missing
            }
          });
        break;
      default:
        sortedData = data && [...data];
    }
    setData(sortedData);
    // return sortedData;
  };
  

  const dataResult=props && props.data && props.data;
  const paid=props && props.paid && props.paid;
  return (
    <div style={{ position: "relative" }}>
      {" "}
      <div className="cardHeadingDebt" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap:"4px"
      }}>Individual Progress
      
      <div
      className="filterIcons"
      onClick={() => {
        // setDropdown(!dropdown);
      }}
    >
      <Dropdown
        trigger={["click"]}
        overlay={
          <Menu>
            <Menu.Item>
              <div
                onClick={() => {
                  sortData("alphabetical");
                }}
              >
                Alphabetical
              </div>
            </Menu.Item>
           {/* <Menu.Item>
              <div
                onClick={() => {
                  sortData("percentage");
                }}
              >
                Percentage
              </div>
              </Menu.Item> */}
            <Menu.Item>
              <div
                onClick={() => {
                  sortData("initialLoanAmount");
                }}
              >
                Amount
              </div>
            </Menu.Item>
            <Menu.Item>
              <div
                onClick={() => {
                  sortData("interestRate");
                }}
              >
                ARP
              </div>
            </Menu.Item>
          </Menu>
        }
      >
        <a
          className="ant-dropdown-link"
          onClick={(e) => e.preventDefault()}
        >
          <img src={filterIcon} height={24} width={24} alt="icon"></img>
        </a>
      </Dropdown>
    </div>
      </div>
      <div className="listingContainer" style={{paddingInline:"8px"}}>
        <React.Fragment>
          {data && data.length > 0 ? (
            data.map((item, index) => {
              const relevantTransactions = props && props.paid && props.paid.filter(transaction => transaction.itemId ===  item.item.id);
              const totalAmountPaid = relevantTransactions && relevantTransactions.reduce((accumulator, transaction) => {
                return accumulator + transaction.amount;
              }, 0);
              return (
              <div key={index} className="" style={{display:"flex", gap:"1rem", marginTop:"8px"}}>
              <img src={item.item && item.item.image ? item.item.image : budgetIcon} width={40} height={40}></img>
              <div style={{width:"100%"}}>
                <div className="budgetDropDown">
                  <span className="budgetCardTitle">
                  {item && item.item && item.item["Nickname of Liabilities"]} ({item && item.item && item.item.module && item.item.module==="Real Estates" ? "Real Estate" : item.item.module})
                  </span>
                  <span>{item && item.item && item.item["Initial Loan Amount"] !== undefined && totalAmountPaid
                ? `${totalAmountPaid && item.item["Initial Loan Amount"] && ((totalAmountPaid/item.item["Initial Loan Amount"] )*100).toFixed(2)}%` : "0%"}</span> 
                </div>
                <Progress
                  className="budgetProgress"
                  type="line"
                  height="40px"
                  strokeColor={
                    totalAmountPaid && totalAmountPaid
                      ?  totalAmountPaid > item.item && item.item["Initial Loan Amount"] && item.item["Initial Loan Amount"]
                        ? "#f5222d"
                        : "#2a3da3"
                      : "#2a3da3"
                  }
                  trailColor="#333533"
                  percent={totalAmountPaid && item.item["Initial Loan Amount"] && ((totalAmountPaid/item.item["Initial Loan Amount"] )*100)}
                  showInfo={false}
                />
                <div className="budgetDropDown">
                <span className="budgetCardTitle">
                {/*  ${item.monthlyPayment && item.monthlyPayment.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}  of */}
                 ${item && item.item  && item.item["Initial Loan Amount"] && item.item["Initial Loan Amount"].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
                </div>
              </div>
              </div>)
          })
          ) : (
            <div className="nodata">No data to show</div>
          )}
        </React.Fragment>
        {/*<div key={index} className="list-row-no" style={{flexDirection:"column"}}>
                <div style={{display:"flex", justifyContent:"space-between", gap:"1rem"}}>
                  <div className="listname-dark">
                    <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                      {item.name}
                    </div>
                    <div style={{ fontWeight: "400" }}>{item.module}</div>
                  </div>
                  <div>
                    <img src={bagImage} alt="bag"></img>
                  </div>
                </div>
                  <Progress
                    strokeColor={"#2a3da3"}
                    percent={item.amortizationPercentage && item.amortizationPercentage}
                    style={{ marginTop: "2rem" }}
                    status="active"
                  />
               
            </div> */}
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
